import { makeContextModule } from '../../../../../common/utils/makeContextModule';

export interface IControlsContext {
  ymaps: YMaps.IYMaps;
  map: YMaps.Map;
}

export const {
  Context: ControlsContext,
  useContext: useControlsContext,
  withContext: withControlsContext,
} = makeContextModule<IControlsContext>({
  contextName: 'ControlsContext',
});
